module.exports = __webpack_public_path__ + "img/my-nano-ninja-logo.3c674c05.png";